import * as React from "react"
import Layout from "../../components/layout"
import Seo from "../../components/seo"
import CommonHero from "../../sections/technologies/common-hero"
import CommonInfo from "../../sections/technologies/common-info"
import CommonHead from "../../sections/technologies/common-head"
import superbetterImage from "../../images/sections/services/superbetter.webp"
import insummaryImage from "../../images/sections/services/insummary.webp"
import computerIcon from "../../images/sections/technologies/computer.svg"
import storageIcon from "../../images/sections/technologies/storage.svg"
import databaseIcon from "../../images/sections/services/database.svg"
import networkIcon from "../../images/sections/technologies/network.svg"
import securityIcon from "../../images/sections/technologies/security.svg"
import devOPsIcon from "../../images/sections/services/dev-ops.svg"
import AIMLTechIcon from "../../images/sections/services/ai-ml-tech.svg"
import analyticsIcon from "../../images/sections/technologies/analytics.svg"
import internetIcon from "../../images/sections/technologies/internet.svg"
import serverLessIcon from "../../images/sections/technologies/server-less.svg"
import GenAIIcon from "../../images/sections/services/GenAI.svg"
import migrationIcon from "../../images/sections/technologies/migration.svg"
import blockchainIcon from "../../images/sections/technologies/blockchain.svg"
import hybridCloudIcon from "../../images/sections/technologies/hybrid-cloud.svg"
import developerToolIcon from "../../images/sections/technologies/developer-tool.svg"
import articleImage from "../../images/article-image.png"

import CommonFaqs from "../../sections/technologies/common-faqs"
import CommonProjects from "../../sections/technologies/common-projects"
import CommonTechnologies from "../../sections/technologies/common-technologies"
import CommonIndustries from "../../sections/technologies/common-industries"
import CommonUseCases from "../../sections/technologies/common-usecases"
import CommonInsights from "../../sections/technologies/common-insights"
import ScrollToTop from "../../components/Buttons/ScrollToTop"

const infoData = {
  label:
    "Empower your enterprise with scalable, secure cloud solutions tailored to your needs!",
  description:
    "Transform your business with our robust cloud services, designed to scale with your needs while ensuring top-notch security and performance. Whether it's computing power, storage, or advanced AI, we provide tailored solutions to drive your success.",
}

const heroData = {
  label: "Cloud Services",
  description:
    "At Brim Labs, our cloud experts design and implement scalable, secure cloud solutions tailored to industries like fintech, healthtech, and SaaS. We utilize cutting-edge cloud platforms and best practices to optimize performance, ensure reliability, and drive your business forward in the digital age.",
  buttonText: "Book a Call",
}

const faqData = {
  section: "FAQs",
  label: "Ask us anything",
  // faqTitle:
  //   "Here, we have gathered a list of FAQs on Salesforce Development that you might have and many of our partners have asked us.",
  faqs: [
    {
      header: "What Cloud Services do you offer?",
      description:
        "We offer a wide range of cloud services, including cloud infrastructure setup, cloud migration, cloud-native application development, DevOps automation, cloud security, disaster recovery, and managed cloud services. We work with leading cloud providers such as AWS, Microsoft Azure, and Google Cloud to deliver scalable, secure, and cost-effective solutions",
    },
    {
      header: "What cloud platforms do you work with?",
      description:
        "We work with all major cloud platforms, including Amazon Web Services (AWS), Microsoft Azure, Google Cloud Platform (GCP), and IBM Cloud. Depending on your business needs, we help you choose the right platform and services to optimize performance, scalability, and cost.",
    },
    {
      header: "How do you ensure the security of cloud infrastructure",
      description:
        "We prioritize cloud security by implementing multi-layered security measures, including encryption, identity and access management (IAM), firewalls, and network security configurations. We also follow industry best practices and adhere to compliance standards like ISO 27001, HIPAA, and GDPR to ensure your data and applications remain secure.",
    },
    {
      header: "What is your approach to cloud migration?",
      description:
        "Our approach to cloud migration begins with a detailed assessment of your current infrastructure, applications, and business needs. We create a customized migration plan to minimize downtime and ensure a seamless transition. We use cloud-native tools and methodologies to safely migrate data and applications while maintaining security and performance throughout the process.",
    },
    {
      header: " How do you help businesses optimize cloud costs?",
      description:
        "We help optimize cloud costs by analyzing your usage patterns, identifying underutilized resources, and recommending cost-effective strategies like autoscaling, reserved instances, and pay-as-you-go pricing models. We also provide ongoing monitoring and optimization to ensure you only pay for the resources you need.",
    },
    {
      header: " Do you offer multi-cloud or hybrid cloud solutions?",
      description:
        "Yes, we offer both multi-cloud and hybrid cloud solutions. For businesses that want to leverage the strengths of multiple cloud providers or maintain a combination of on-premises and cloud infrastructure, we design and implement seamless integrations that allow you to manage workloads across different environments efficiently.",
    },
    {
      header: "How do you ensure scalability in cloud solutions?",
      description:
        "We design cloud solutions with scalability in mind by using cloud-native services like autoscaling, load balancing, and distributed systems. Whether you're handling sudden traffic spikes or planning for future growth, we ensure your cloud infrastructure can scale dynamically without compromising performance or reliability.",
    },
    {
      header: " How do you provide ongoing cloud management and support?",
      description:
        "We offer managed cloud services to monitor, maintain, and optimize your cloud infrastructure on an ongoing basis. This includes performance monitoring, security audits, cost management, regular updates, and troubleshooting. Our goal is to ensure your cloud environment runs smoothly and efficiently, allowing you to focus on your core business.",
    },
  ],
}

const projectData = [
  {
    label: "SuperBetter",
    description:
      "Ace the game of mental health with SuperBetter. Boost your emotional well-being, and improve your mental resilience with one of the best mental gamification applications.",
    stats: [
      { heading: 1000000, subheading: "Users" },
      { heading: "Seed", subheading: "Funded" },
      { heading: "Global", subheading: "Userbase" },
    ],
    tags: ["Mental Health", "Gaming", "E-Learning"],
    link: "/success-stories/superbetter",

    image: superbetterImage,
  },
  {
    label: "Insummary",
    description:
      "An AI-Powered Productivity Platform for Retail and Wholesale Insurance Brokers. Generate Policy summary or compare different policies at a time and gain valuable insights in minutes.",
    stats: [],
    tags: ["Insurance", "SaaS", "Generative AI", "AI", "ML"],
    link: "/success-stories/insummary-ai",
    hasNoDetailPage: true,
    image: insummaryImage,
  },
]

const technologyData = {
  section: "Cloud Services",
  label: "Tech Stack",
  technologies: [
    {
      label: "Computer Services",
      icon: computerIcon,
      features: [
        "Amazon Web Services (AWS)",
        "Microsoft Azure",
        "Google Cloud Platform (GCP)",
        "IBM Cloud",
        "Oracle Cloud",
      ],
    },
    {
      label: "Storage Services",
      icon: storageIcon,
      features: [
        "AWS:S3",
        "AWS: Glacier",
        "AWS EBS",
        "Azure Blob Storage",
        "Azure Disk Storage",
        "Azure: File Storage",
        "GCP:Filestore",
        "GCP: Persistent Disks",
        "GCP:Cloud Storage",
        "IBM Cloud: IBM Cloud Object Storage",
        "IBM Cloud Block Storage",
        "Oracle Cloud Oracle Object Storage",
        "Oracle Cloud Archive Storage",
      ],
    },
    {
      label: "DataBase Services",
      icon: databaseIcon,
      features: [
        "AWS.RDS",
        "AWS: DynamoDB",
        "AWS: Aurora",
        "Azure SQL Database",
        "Azure Cosmos DB",
        "Azure Database for MySQL/PostgreSQL",
        "GCP:Cloud SQL",
        "GCP:Bigtable",
        "GCP Firestore",
        "IBM Cloud IBMDb2",
        "IBM Cloud Cloudant",
        "Oracle Cloud Autonomous Database",
        "Oracle Cloud NoSQL Database",
      ],
    },
    {
      label: "Networking Services",
      icon: networkIcon,
      features: [
        "AWS:VPC",
        "AWS: Route 53",
        "AWS CloudFront",
        "Azure: Virtual Network",
        "Azure Azure DNS",
        "Azure: Traffic Manager",
        "GCP:VPC",
        "GCP:Cloud DNS",
        "GCP:CloudCDN",
        "IBM Cloud Virtual Private Cloud (VPC)",
        "IBM Cloud CDN",
        "Oracle Cloud VCN",
        "Orade Cloud: DNS",
      ],
    },
    {
      label: "Security Services",
      icon: securityIcon,
      features: [
        "AWS Identity and Access Management (IAM)",
        "AWS Shield",
        "AWS: KMS",
        "Azure: KeyVault",
        "Azure Active Directory",
        "Azure Security Center",
        "GCP:Cloud IAM",
        "GCP Security Command Center",
        "GCP:Cloud KMS",
        "Orade Cloud: IAM",
        "Oracle Cloud Guard",
        "IBM Cloud IAM",
        "IBM Cloud Key Protect",
      ],
    },
    {
      label: "DevOps Services",
      icon: devOPsIcon,
      features: [
        "AWS CodePipeline",
        "AWS CodeBuild",
        "AWS CodeDeploy",
        "Azure DevOps",
        "Azure Pipelines",
        "Azure Artifacts",
        "GCP:Cloud Build",
        "GCP: Cloud Source Repositories",
        "GCP: Cloud Deployment Manager",
        "IBM Cloud Tekton Pipelines",
        "IBM Cloud Cloud Continuous Delivery",
        "Oracle Cloud Developer Cloud Service",
        "Oracle Cloud Resource Manager",
      ],
    },
    {
      label: "Artificial Intelligence & Machine Learning",
      icon: AIMLTechIcon,
      features: [
        "AWS. SageMaker",
        "AWS. Rekognition",
        "AWS: Translate",
        "Azure: Machine Leaming",
        "Azure Cognitive Services",
        "Azure: Bot Service",
        "GCP:Al Platform",
        "GCP: Vision Al",
        "GCP: AutoML",
        "IBM Cloud Watson",
        "IBM Cloud Watson Studio",
        "Oracle Cloud Oracle Al",
        "Oracle Cloud Data Science",
      ],
    },
    {
      label: "Analytics Services",
      icon: analyticsIcon,
      features: [
        "AWS Redshift",
        "AWS Athena",
        "AWS QuickSight",
        "Azure Synapse Analytics",
        "Azure PowerBI",
        "Azure Data Lake",
        "GCP: BigQuery",
        "GCP: Dataflow",
        "GCP: Looker",
        "IBM Cloud Cognos Analytics",
        "IBM Cloud:Db2 Warehouse",
        "Oracle Cloud Analytics Cloud",
        "Oracle Cloud Big Data Service",
      ],
    },
    {
      label: "Internet of Things (IoT) Services",
      icon: internetIcon,
      features: [
        "AWS IoT Core",
        "AWS IoT Greengrass",
        "AWS IoT Analytics",
        "Azure: loT Hub",
        "Azure Digital Twins",
        "Azure IoT Central",
        "GCP: Cloud IoT Core",
        "GCP: Cloud loT Edge",
        "IBM Cloud Watson IoT Platform",
        "Oracle Cloud IoT Cloud Service",
      ],
    },
    {
      label: "Serverless Computing",
      icon: serverLessIcon,
      features: [
        "AWS Lambda",
        "AWS: Fargate",
        "Azure: Functions",
        "Azure: Logic Apps",
        "GCP: Cloud Functions",
        "GCP Cloud Run",
        "IBM Cloud Functions",
        "Oracle Cloud Functions",
      ],
    },
    {
      label: "Content Delivery Networks (CDN)",
      icon: GenAIIcon,
      features: [
        "AWS CloudFront",
        "Azure Azure CDN",
        "GCP: Cloud CDN",
        "IBM Cloud CDN",
        "Oracle Cloud CDN",
      ],
    },
    {
      label: "Migration Services",
      icon: migrationIcon,
      features: [
        "AWS Migration Hub",
        "AWS Server Migration Service (SMS)",
        "AWS. Database Migration Service (DMS)",
        "Azure: Site Recovery",
        "Azure: Migrate",
        "GCP: Migrate for Compute Engine",
        "GCP: Cloud Endure",
        "IBM Cloud Migration Services",
        "Oracle Cloud Oracle Cloud Infrastructure (OCI) Migration",
      ],
    },
    {
      label: "Blockchain Services",
      icon: blockchainIcon,
      features: [
        "AWS Amazon Managed Blockchain",
        "Azure Blockchain Service",
        "GCP: Blockchain Node Engine (Blockchain partnerships rather than a direct service)",
        "IBM Cloud Blockchain Platform",
        "Oracle Cloud Blockchain Platform",
      ],
    },
    {
      label: "Hybrid Cloud & Multi-Cloud Services",
      icon: hybridCloudIcon,
      features: [
        "AWS:Outposts",
        "AWS: Transit Gateway",
        "Azure Arc",
        "Azure Stack",
        "GCP: Anthos",
        "IBM Cloud Satellite",
        "IBM Cloud Pak",
        "Oracle Cloud: VMware Solution",
        "Oracle Cloud Interconnect for Azure",
      ],
    },
    {
      label: "Developer Tools",
      icon: developerToolIcon,
      features: [
        "AWS Cloud9",
        "AWS: CodeStar",
        "AWS: X-Ray",
        "Azure: Visual Studio Online",
        "Azure: DevTest Labs",
        "GCP: Cloud SDK",
        "GCP: Cloud Shell",
        "IBM Cloud CLI",
        "IBM Cloud Code Engine",
        "Oracle Cloud Developer Tools",
        "Oracle Cloud Cloud Shell",
      ],
    },
  ],
}

const industriesData = {
  section: "Cloud Services",
  label: "Industries we serve",
  technologies: [
    {
      label: "AI",
    },
    {
      label: "Fintech",
    },

    {
      label: "Healthcare",
    },
    {
      label: "Banking",
    },
    {
      label: "Insurance",
    },
    {
      label: "E-commerce",
    },
    {
      label: "SaaS",
    },
    {
      label: "Retail",
    },
    {
      label: "Logistics",
    },
    {
      label: "Education",
    },
    {
      label: "Agriculture",
    },
    {
      label: "IoT",
    },
    {
      label: "OTT",
    },
    {
      label: "EV",
    },
    {
      label: "Social Media",
    },
    {
      label: "Travel",
    },
  ],
}
const useCasesData = {
  section: "Cloud Services",
  label: "Use Cases",
  cases: [
    {
      title: "AWS",
      rows: 1,
      features: [
        {
          headline: "E-Commerce Platforms",
          description:
            "AWS is ideal for running large-scale e-commerce platforms that require scalability, high availability, and reliability. Services like EC2, S3, and RDS power the infrastructure, while AWS Lambda and API Gateway handle serverless architectures.",
        },
        {
          headline: "Big Data and Analytics",
          description:
            " AWS offers comprehensive big data services like Redshift, EMR, and Athena, making it perfect for processing and analyzing large datasets. It’s widely used for data warehousing, real-time analytics, and machine learning models.",
        },
        {
          headline: "Content Delivery and Streaming",
          description:
            "AWS’s CloudFront, coupled with its global network of data centers, is widely used for content delivery networks (CDNs) and streaming services. It supports high-performance video streaming and fast content delivery to global audiences.",
        },
      ],
    },
    {
      title: "MS Azure",
      rows: 1,
      features: [
        {
          headline: "Enterprise IT and Hybrid Cloud",
          description:
            "Azure is particularly well-suited for enterprises that need to integrate with existing Microsoft products like Windows Server, Active Directory, and SQL Server. Azure’s hybrid cloud capabilities allow businesses to extend their on-premises infrastructure seamlessly to the cloud.",
        },
        {
          headline: "Artificial Intelligence and Machine Learning",
          description:
            " Azure provides a suite of AI and machine learning tools, such as Azure Machine Learning, Cognitive Services, and Bot Service, making it ideal for businesses looking to implement AI-driven solutions like chatbots, predictive analytics, and automation.",
        },
        {
          headline: "Disaster Recovery and Backup",
          description:
            "Azure’s robust disaster recovery solutions, like Azure Site Recovery, enable businesses to ensure data continuity and backup. It’s frequently used by organizations requiring reliable disaster recovery plans and data replication across regions.",
        },
      ],
    },
    {
      title: "GCP",
      rows: 1,
      features: [
        {
          headline: "Big Data and Machine Learning",
          description:
            "GCP excels in big data and machine learning, offering services like BigQuery, Dataflow, and TensorFlow. It’s ideal for companies focused on data analytics, predictive modeling, and large-scale data processing.",
        },
        {
          headline: "Application Development and Deployment",
          description:
            "GCP provides comprehensive tools for application development and deployment, such as App Engine, Kubernetes Engine, and Cloud Functions. It’s particularly strong in supporting microservices and containerized applications.",
        },
        {
          headline: "Gaming Industry",
          description:
            " GCP is popular in the gaming industry, providing scalable infrastructure, global networking, and real-time analytics through services like Google Kubernetes Engine and Cloud Spanner. It’s used for game hosting, multiplayer gaming, and analytics.",
        },
      ],
    },
    {
      title: "IBM Cloud",
      rows: 1,
      features: [
        {
          headline: "AI and Watson Services",
          description:
            "IBM Cloud is known for its AI capabilities, particularly through IBM Watson. It’s used in industries like healthcare, finance, and customer service to build AI-driven applications, chatbots, and data analytics platforms.",
        },
        {
          headline: "Blockchain",
          description:
            "IBM Cloud’s Blockchain Platform is widely used for developing secure and transparent blockchain solutions. It’s ideal for industries like supply chain management, finance, and legal services that require immutable transaction records.",
        },
        {
          headline: "Hybrid Cloud and Enterprise IT",
          description:
            "IBM Cloud is tailored for enterprises looking to build hybrid cloud environments. It integrates with existing on-premises systems, providing businesses with flexibility and control over their IT infrastructure.",
        },
      ],
    },
    {
      title: "Oracle Cloud",
      rows: 1,
      features: [
        {
          headline: "Enterprise Resource Planning (ERP)",
          description:
            "Oracle Cloud is a leader in ERP solutions, offering comprehensive services for finance, HR, and supply chain management. It’s ideal for large enterprises looking to migrate their traditional ERP systems to the cloud.",
        },
        {
          headline: "Database Management",
          description:
            "Oracle Cloud provides robust database solutions, particularly for running Oracle Database workloads in the cloud. It’s suited for businesses requiring high-performance, scalable, and secure database management.",
        },
        {
          headline: "High-Performance Computing (HPC)",
          description:
            "Oracle Cloud’s infrastructure is optimized for high-performance computing tasks, such as scientific simulations, financial modeling, and complex data analysis. It’s used in industries like finance, engineering, and research.",
        },
      ],
    },
  ],
}
const insightData = {
  label: "Insights on Cloud",
  categoryId: 42,
  insights: [
    {
      image: articleImage,
      description:
        "As a tight-knit team of experts, we create memorable and emotional websites, digital experiences, and native apps. ",
      heading: "MVP Development for Startups",
      subheading: "Development",
    },
    {
      image: articleImage,
      description:
        "As a tight-knit team of experts, we create memorable and emotional websites, digital experiences, and native apps. ",
      heading: "MVP Development for Startups",
      subheading: "Development",
    },
    {
      image: articleImage,
      description:
        "As a tight-knit team of experts, we create memorable and emotional websites, digital experiences, and native apps. ",
      heading: "MVP Development for Startups",
      subheading: "Development",
    },
  ],
}
const CloudServices = () => {
  return (
    <Layout>
      <Seo
        title="Cloud Services | Brim Labs Technologies"
        description="Scalable cloud solutions for secure, efficient, and flexible business growth."
        keywords="cloud solutions, cloud computing, cloud integration, scalable infrastructure, cloud security, business continuity"
      />
      <CommonHead activePage="cloud-services" />
      <CommonHero data={heroData} />
      <CommonTechnologies data={technologyData} />
      <ScrollToTop />
      <CommonUseCases data={useCasesData} />
      <CommonInfo data={infoData} maxWidth={"md:max-w-[90%]"} />
      <CommonIndustries data={industriesData} />
      <CommonProjects data={projectData} />
      <CommonInsights data={insightData} />
      <CommonFaqs data={faqData} />
    </Layout>
  )
}

export default CloudServices
